<template>
  <div v-if="isOpen" class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-content">
      <button class="modal-close" @click="$emit('close')">×</button>
      <div class="modal-header">
        <slot name="header" />
      </div>
      <div class="modal-body">
        <slot />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{ isOpen: boolean }>();
const emit = defineEmits(['close']);
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1000;
  padding: 2rem 1rem;
  overflow-y: auto;
}
.modal-content {
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  width: 100%;
  max-width: 780px;
  position: relative;
  box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25);
  /* Allow absolutely positioned dropdowns to overflow */
  overflow: visible;
}
.modal-header {
  margin-bottom: 1.5rem;
  padding-right: 2rem;
}
.modal-body {
  /* Scrollable body inside the modal */
  overflow: visible;
}
.modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #64748b;
  line-height: 1;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  transition: background 0.15s;
}
.modal-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}
</style>
